import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/manga';

export default function RankingSection() {
  const ranking = [...mangas].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-label="人气排行榜">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
              Ranking
            </span>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">人气排行榜</h2>
          </div>
          <Link
            to="/category"
            className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
          >
            全部作品
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {ranking.map((manga, idx) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="group flex items-center gap-4 rounded-lg bg-background-50 px-4 py-3 transition-all hover:bg-background-200/70"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base ${
                  idx < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-secondary-200 text-secondary-900'
                }`}
              >
                {idx + 1}
              </span>
              <span className="relative h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={manga.cover}
                  alt={`${manga.title}漫画排行`}
                  title={`${manga.title}漫画免费阅读`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {manga.title}
                </span>
                <span className="mt-0.5 block truncate text-xs text-foreground-600">
                  {manga.tags.slice(0, 2).join(' · ')} · {manga.status}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-600">
                <i className="ri-eye-line" aria-hidden="true" />
                {(manga.views / 10000).toFixed(0)}万
              </span>
              <span className="hidden shrink-0 items-center gap-1 text-xs text-secondary-700 sm:flex">
                <i className="ri-star-fill" aria-hidden="true" />
                {manga.rating}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}